import { useState } from 'react';

import { isRovoTtaiSegmentRenderStabilizationEnabled } from './isRovoTtaiSegmentRenderStabilizationEnabled';

export const useRovoTtaiSegmentRenderStabilizationEnabled = (): boolean => {
	const [isEnabled] = useState(isRovoTtaiSegmentRenderStabilizationEnabled);

	return isEnabled;
};
